import { render, staticRenderFns } from "./FieldConfigurator.vue?vue&type=template&id=138a19df&scoped=true&"
import script from "./FieldConfigurator.vue?vue&type=script&lang=js&"
export * from "./FieldConfigurator.vue?vue&type=script&lang=js&"
import style0 from "./FieldConfigurator.vue?vue&type=style&index=0&id=138a19df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138a19df",
  null
  
)

export default component.exports